module.exports = __webpack_public_path__ + "static/media/task.23af2d86.svg";